import React from "react";
import disc_login from "assets/image/disc_login.png";

export default function PesertaInMobile() {
  return (
    <div className="in-mobile-wrapper">
      <img src={disc_login} style={{ width: "100%" }} />
      <br />
      <p className="semi-bold">
        Halaman assessment tidak dapat diakses melalui perangkat mobile. Silakan
        gunakan laptop atau komputer.
      </p>
    </div>
  );
}
